import { useCallback } from 'react'
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'
import { signOut } from 'aws-amplify/auth'
import axios from 'axios'

import ROUTES from '../consts/paths'
import { resetAction, useAppDispatch } from '../store'
import { hasUserPoolConfigured } from '../utils/amplifyConfig'
import { queryClient } from '../components/Providers/ReactQueryProvider'
import { resetFavicon } from '../utils/favicon'

export const useLogout = (): { logOutUser: () => Promise<void>, clearClientState: () => void } => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [, , removeCookie] = useCookies(['edlink_access_token_exists', 'edlink_refresh_token_exists'])

  const clearClientState = (): void => {
    resetFavicon()
    dispatch(resetAction())
    queryClient.clear()

    removeCookie('edlink_access_token_exists', { partitioned: true })
    removeCookie('edlink_refresh_token_exists', { partitioned: true })

    localStorage.clear()
    sessionStorage.clear()

    // Notify context to update Edlink session state
    window.dispatchEvent(new Event('edlink-logout'))
  }

  const logOutUser = useCallback(async () => {
    resetFavicon()

    // Best-effort: server logout
    try {
      await axios.post('/api/auth/logout')
    } catch (e) {
      console.warn('Server logout failed (continuing):', e)
    }

    // Best-effort: Cognito logout (only if configured)
    if (hasUserPoolConfigured()) {
      try {
        console.log('Signing out from Cognito...')
        await signOut()
      } catch (e) {
        console.warn('Cognito signOut failed (continuing):', e)
      }
    }

    clearClientState()
  }, [dispatch, navigate, removeCookie])

  return { logOutUser, clearClientState }
}
